export type PendingAuthAction =
  | {
      type: "bootstrap-household";
      redirectTo?: string;
      deferBootstrapUntilResolve?: boolean;
      requestId?: string;
    }
  | {
      type: "accept-invite";
      token: string;
      redirectTo?: string;
    }
  | {
      type: "redirect";
      redirectTo: string;
    };

const STORAGE_KEY = "meongnyang_pending_auth_action";

export function getPendingAuthAction(): PendingAuthAction | null {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as PendingAuthAction) : null;
  } catch {
    return null;
  }
}

export function setPendingAuthAction(action: PendingAuthAction | null) {
  if (typeof window === "undefined") {
    return;
  }

  try {
    if (!action) {
      window.localStorage.removeItem(STORAGE_KEY);
      return;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(action));
  } catch {
    // Ignore storage failures and fall back to runtime flow.
  }
}
